import axios from 'axios';
import store from '@/store';
import endpointVersion from '@/helpers/endpoint-version';
export const getHistoricLogs = (payload) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios.get('/audience/getExportLogs', {
        baseURL: endpointVersion('v3'),
        params: {
            brand: brand.id,
            audienceId: payload.audienceId,
            connectorId: payload.connectorId,
            limit: payload.limit,
            page: payload.page,
            orderBy: payload.orderBy,
        },
        headers: { Authorization: `Bearer ${tokenV3}` },
    });
};
